import { useCallback, useState } from 'react';

import { downloadSalesOrderExcel } from '#/api/crmMgmt/salesOrder/downloadExcel';
import { getSalesOrderApiErrorMessage } from '#/modules/crmMgmt/salesOrder/helper/apiError';
import { getFileTransferErrorMessage } from '#/utils/blobResponseError';
import { triggerBlobDownload } from '#/utils/downloadBlob';
import { toast } from '#/utils/toast';

/**
 * 銷貨單 Detail 快速列印（GET excel）。
 *
 * @param {string} [id]
 */
function useSalesOrderExcelDownload(id) {
  const [isPrintPending, setIsPrintPending] = useState(false);

  const handlePrint = useCallback(async ({ hideAmounts } = {}) => {
    if (!id || isPrintPending) {
      return;
    }

    setIsPrintPending(true);
    try {
      const { blob, filename } = await downloadSalesOrderExcel(id, { hideAmounts });
      triggerBlobDownload(blob, filename);
    } catch (error) {
      toast.error(
        getFileTransferErrorMessage(error)
        || getSalesOrderApiErrorMessage(error, '下載 Excel 失敗'),
      );
    } finally {
      setIsPrintPending(false);
    }
  }, [id, isPrintPending]);

  return {
    canPrint: Boolean(id),
    isPrintPending,
    handlePrint,
  };
}

export default useSalesOrderExcelDownload;
